import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-final',
  templateUrl: './final.component.html',
  styleUrls: ['./final.component.scss']
})

export class FinalComponent implements OnInit {
  @Input() data: any;

  constructor() {
  }

  ngOnInit() {
    window.scroll(0, -1);
  }
}
